export default "__VITE_ASSET__Czs3K_bE__"